export default {
  BEHATZAILE_TOKEN: 'YjNoNHR6NDFsMw==',
};



// WEBPACK FOOTER //
// ./src/constants/Integration.constants.js